const Modules = [
  {
    id: 1,
    module: "Calender Module",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 2,
    module: "TimeSheet Module",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: false,
  },
  {
    id: 3,
    module: "Employees Module",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 4,
    module: "Holiday Module",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 5,
    module: "Locations Module",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 6,
    module: "Payroll Module",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 7,
    module: "Query Module",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: false,
    isEdit: true,
    isDelete: false,
  },
  {
    id: 8,
    module: "Reports Module",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    id: 9,
    module: "Services Module",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 10,
    module: "Roles Module",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 11,
    module: "Help Module",
    viewglobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
]

export default Modules
